import FlightContainer from "./components/FlightContainer";
import FlightDataInput from "./components/FlightDataInput";
import Header from "./components/Header";

export default function Layout() {
    return (
        <>
            <Header />

            <section>
                {/* Input Data */}
                <FlightDataInput />

                {/* <!-- Preview Data --> */}
                <FlightContainer />
            </section>
        </>
    );
}